'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagList = exports.taggedContent = exports.contentTagsV2 = exports.contentTags = undefined;

var _sagaTools = require('@classpass/saga-tools');

var contentTags = exports.contentTags = (0, _sagaTools.makeEntityScaffold)('SAGA.API.GET_CONTENT_TAGS', function (client, type, ids) {
  return client.tags.contentTags({ content_type: type, content_ids: ids }).then(function (data) {
    return data.content;
  });
}, { defaultKey: function defaultKey(client, type, ids) {
    return type + '_' + ids.join('_');
  } }); /* eslint-disable import/prefer-default-export */

var contentTagsV2 = exports.contentTagsV2 = (0, _sagaTools.makeEntityScaffold)('SAGA.API.GET_CONTENT_TAGS_V2', function (client, type, ids) {
  return client.tags.contentTagsV2({ content_type: type, content_ids: ids }).then(function (data) {
    return data.content;
  });
}, { defaultKey: function defaultKey(client, type, ids) {
    return type + '_' + ids.join('_');
  } });

var taggedContent = exports.taggedContent = (0, _sagaTools.makeEntityScaffold)('SAGA.API.GET_TAGGED_CONTENT', function (client, type, tags) {
  return client.tags.taggedContent({ content_type: type, tags: tags }).then(function (data) {
    return data.content_ids;
  });
}, { defaultKey: function defaultKey(client, type, tags) {
    return type + '_' + tags.join('_');
  } });

var tagList = exports.tagList = (0, _sagaTools.makeEntityScaffold)('SAGA.API.GET_TAGS', function (client, options) {
  return client.tags.getV3(options).then(function (data) {
    return data.tags;
  });
}, { defaultKey: 1 });